import { authApiService } from '@/api/authApiService';
import { ApiResponseType, AuthResponseType } from '@/types/sharedTypes';

export type LoginVerifyPasswordType = {
  password: string;
};

export const loginVerifyPasswordApi = (data: LoginVerifyPasswordType): Promise<ApiResponseType<AuthResponseType>> => {
  const uri = '/users/auth/password/';

  return authApiService.POST(uri, data);
};
